import React from "react";

export interface PreferenceRowProps {
  label: string;
  labelClassName: string;
  icon: React.ReactNode;
  value: React.ReactNode;
}

const PreferenceRow = ({
  label,
  labelClassName,
  icon,
  value,
}: PreferenceRowProps) => (
  <div className="flex flex-col gap-2 text-s sm:items-start md:flex-row">
    <span
      className={`inline-flex h-[22px] w-content shrink-0 items-center justify-center gap-0.5 rounded-[10px] px-2 py-0.5 font-primary ${labelClassName}`}
    >
      {icon}
      {label}
    </span>
    <p className="text-base">{value}</p>
  </div>
);

export default PreferenceRow;
